<script>
import TalkizyAPI from '@app/services/API/Talkizy';

export default {
  i18n: {
    messages: {
      fr: {
        disconnect_title: 'Déconnexion de Talkizy',
        disconnect_warning: 'Votre espace Teachizy sera déconnecté de Talkizy. Vos classes virtuelles ne seront plus accessibles depuis Teachizy.',
        reconnect_note: 'Vous pourrez reconnecter votre espace à tout moment depuis cette page.',
        disconnect_button: 'Déconnecter mon espace',
        confirm_disconnect: 'En déconnectant votre espace de Talkizy :'
          + '<ul class="mt-2 mb-3" style="list-style: disc; text-align: left; padding-left: 1.25rem;">'
          + '<li>vous ne pourrez plus créer ni gérer de classes virtuelles depuis Teachizy ;</li>'
          + '<li>vos classes virtuelles existantes ne seront plus accessibles depuis Teachizy '
          + '(elles restent dans votre espace Talkizy) ;</li>'
          + '<li>les membres de votre équipe perdront l\'accès aux classes virtuelles depuis Teachizy.</li>'
          + '</ul>'
          + 'Vous pourrez reconnecter votre espace à tout moment depuis cette page.',
        owner_only: 'Seul le propriétaire de l\'espace peut déconnecter Talkizy.',
        ok: 'Ok !',
        cancel: 'Annuler',
      },
      en: {
        disconnect_title: 'Disconnect Talkizy',
        disconnect_warning: 'Your Teachizy workspace will be disconnected from Talkizy. Your virtual classrooms will no longer be accessible from Teachizy.',
        reconnect_note: 'You can reconnect your workspace anytime from this page.',
        disconnect_button: 'Disconnect my workspace',
        confirm_disconnect: 'By disconnecting your workspace from Talkizy:'
          + '<ul class="mt-2 mb-3" style="list-style: disc; text-align: left; padding-left: 1.25rem;">'
          + '<li>you will no longer be able to create or manage virtual classrooms from Teachizy;</li>'
          + '<li>your existing virtual classrooms will no longer be accessible from Teachizy '
          + '(they remain in your Talkizy workspace);</li>'
          + '<li>your team members will lose access to virtual classrooms from Teachizy.</li>'
          + '</ul>'
          + 'You can reconnect your workspace anytime from this page.',
        owner_only: 'Only the workspace owner can disconnect Talkizy.',
        ok: 'Ok!',
        cancel: 'Cancel',
      },
    },
  },
  computed: {
    isOwner() {
      return this.$store.getters['auth/isRoleOwner'];
    },
  },
  methods: {
    disconnect() {
      this.$buefy.dialog.confirm({
        title: this.$t('disconnect_title'),
        message: this.$t('confirm_disconnect'),
        type: 'is-danger',
        hasIcon: true,
        icon: 'exclamation-triangle',
        iconPack: 'fas',
        confirmText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onConfirm: () => {
          const loader = this.$buefy.loading.open();
          TalkizyAPI.disconnect()
            .then(async() => {
              await this.$store.dispatch('auth/fetch');
              this.$showMessage.success();
            })
            .catch((error) => this.$errorHandlers.axios(error))
            .finally(() => loader.close());
        },
      });
    },
  },
};
</script>

<template>
  <div class="box">
    <div class="content">
      <h2 class="is-size-6">
        {{ $t('disconnect_title') }}
      </h2>
      <p>
        {{ $t('disconnect_warning') }} {{ $t('reconnect_note') }}
      </p>
    </div>
    <p class="has-text-right">
      <b-tooltip
        v-if="!isOwner"
        :label="$t('owner_only')"
        position="is-left"
        multilined
      >
        <b-button type="is-danger" outlined disabled>
          {{ $t('disconnect_button') }}
        </b-button>
      </b-tooltip>
      <b-button v-else type="is-danger" outlined @click="disconnect">
        {{ $t('disconnect_button') }}
      </b-button>
    </p>
  </div>
</template>
